import ClassNames from 'classnames';
import React from 'react';
import styles from './index.module.less';
import { NewBaseIcon } from '@shared/components/base/NewBaseIcon';
import { whole_loading } from '@shared/assets/svg/base';

interface LoadingProps {
	className?: string;
	style?: React.CSSProperties;
	icon?: string;
	color?: string;
	size?: number;
}

export const BaseLoading = (props: LoadingProps) => {
	const { className, style, icon, color = 'rgba(0,0,0,0.1)', size = 40 } = props;
	const loadingIcon = icon ? icon : whole_loading;
	return (
		<div className={ClassNames(styles.loadingWrap, className)} style={style}>
			{/* <div dangerouslySetInnerHTML={{ __html: loadingIcon }} className={styles.rotate} /> */}
			<NewBaseIcon color={color} size={size} icon={loadingIcon} className={styles.rotate} />
		</div>
	);
};
